const DEFAULT_PART_LIMITS = {
  Vo: 1,
  Cho: 0,
  Gt1: 1,
  Gt2: 0,
  Ba: 1,
  Dr: 1,
  Key: 0,
};

const DEFAULT_PART_ORDER = Object.keys(DEFAULT_PART_LIMITS);

function toSafeInt(value, fallback = 0) {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function normalizeLimit(limit) {
  const normalized = toSafeInt(limit, 0);
  return normalized < 0 ? 0 : normalized;
}

export function getDefaultBandOffConfig() {
  return {
    recruitStatus: "open",
    offDate: null,
    recruitStartAt: null,
    recruitEndAt: null,
    maxParticipants: 0,
    currentParticipants: 0,
    duplicateEntryPolicy: "single_entry_only",
    partLimits: { ...DEFAULT_PART_LIMITS },
    partOrder: [...DEFAULT_PART_ORDER],
  };
}

export function normalizeBandOffConfig(rawConfig = {}) {
  const defaults = getDefaultBandOffConfig();
  const partLimits = { ...defaults.partLimits };

  Object.keys(partLimits).forEach((part) => {
    if (rawConfig.partLimits && Object.prototype.hasOwnProperty.call(rawConfig.partLimits, part)) {
      partLimits[part] = normalizeLimit(rawConfig.partLimits[part]);
    }
  });

  return {
    ...defaults,
    ...rawConfig,
    recruitStatus: rawConfig.recruitStatus === "closed" ? "closed" : "open",
    offDate: rawConfig.offDate || null,
    recruitStartAt: rawConfig.recruitStartAt || null,
    recruitEndAt: rawConfig.recruitEndAt || null,
    maxParticipants: normalizeLimit(rawConfig.maxParticipants ?? defaults.maxParticipants),
    currentParticipants: normalizeLimit(rawConfig.currentParticipants ?? defaults.currentParticipants),
    duplicateEntryPolicy: "single_entry_only",
    partLimits,
    partOrder: Array.isArray(rawConfig.partOrder) && rawConfig.partOrder.length > 0
      ? rawConfig.partOrder.filter((part) => Object.prototype.hasOwnProperty.call(partLimits, part))
      : [...DEFAULT_PART_ORDER],
  };
}

export function normalizeBandOffSongs(rawSongs = []) {
  if (!Array.isArray(rawSongs)) return [];

  return rawSongs
    .map((song, index) => {
      const title = (song.title || "").trim();
      if (!title) return null;

      const availableParts = Array.isArray(song.availableParts)
        ? song.availableParts.filter((part) => DEFAULT_PART_ORDER.includes(part))
        : [...DEFAULT_PART_ORDER];

      return {
        title,
        order: toSafeInt(song.order, index + 1),
        active: song.active !== false,
        availableParts: availableParts.length > 0 ? availableParts : [...DEFAULT_PART_ORDER],
      };
    })
    .filter(Boolean);
}

export function getBandOffPartOrder() {
  return [...DEFAULT_PART_ORDER];
}
